import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { LEGACY_HASH_ROUTES } from './lib/site'
import './index.css'

/**
 * The previous build addressed pages as `#/method`. Anything still linking to
 * those URLs is rewritten to the real path before the router mounts, so old
 * links keep working instead of landing on the home page.
 */
function redirectLegacyHashRoute() {
  const { hash, pathname } = window.location
  if (!hash.startsWith('#/')) return

  const target = LEGACY_HASH_ROUTES[hash]
  if (target && pathname === '/') {
    window.history.replaceState(null, '', target)
  }
}

redirectLegacyHashRoute()

const container = document.getElementById('root')

const tree = (
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </StrictMode>
)

if (container) {
  // Production HTML is prerendered, so it is hydrated. The dev server has no
  // prerender step and serves an empty shell, which must be mounted instead —
  // hydrating an empty root would throw a mismatch on every page.
  // `firstElementChild` rather than `hasChildNodes`: the shell still contains
  // the `<!--app-html-->` placeholder comment, which is a child node.
  if (container.firstElementChild) {
    hydrateRoot(container, tree)
  } else {
    createRoot(container).render(tree)
  }
}
